import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { DialogWizardScreen, useDialogWizardState } from '@futrli/ui-components/components/dialog-wizard';
import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

import { useShareResourceContext } from '../../context/share-resource-context';
import { ShareResourceFormWizardScreen } from '../screens/share-resource-form-wizard-screen';
import { ShareResourceUpdatedWizardScreen } from '../screens/share-resource-updated-wizard-screen';
import { ShareResourceUpdatingWizardScreen } from '../screens/share-resource-updating-wizard-screen';

export interface ShareResourceContainerProps {
  onClose: () => void;
}

export const ShareResourceContainer = ({ onClose }: ShareResourceContainerProps) => {
  const intl = useIntl();
  const { form, view } = useShareResourceContext();

  const handleSave = useCallback(() => {
    view.updateResourcePermissions(form.getRequestData());
  }, [form, view]);

  const { handleAction, handleClose, screen } = useDialogWizardState({
    error: view.state.errorUpdating,
    isLoading: view.state.isUpdating,
    onAction: handleSave,
    onClose
  });

  if (view.state.isLoading || !view.state.resourcePermissions) {
    return <LoadingWizardScreen />;
  }

  if (screen === DialogWizardScreen.LOADING) {
    return <ShareResourceUpdatingWizardScreen />;
  }

  if (screen === DialogWizardScreen.SUCCESS) {
    return <ShareResourceUpdatedWizardScreen onClose={handleClose} />;
  }

  return (
    <ShareResourceFormWizardScreen
      error={
        screen === DialogWizardScreen.ERROR
          ? intl.formatMessage({
            id: 'sharing.save_error',
            defaultMessage: 'Unable to save sharing settings. Try again.'
          })
          : undefined
      }
      onCancel={handleClose}
      onSave={handleAction}
    />
  );
};
